import React from 'react';
export function TermsConditions() {
  return <div className="w-full bg-white py-16" data-id="element-555">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-556">
        <h1 className="text-4xl font-bold text-slate-800 mb-8" data-id="element-557">
          Terms & Conditions
        </h1>
        <div className="prose prose-slate max-w-none" data-id="element-558">
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-559">
            1. Our Services
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-560">
            Brighthands provides domestic appliance services including:
          </p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-561">
            <li data-id="element-562">Diagnostics and fault assessment</li>
            <li data-id="element-563">Repair work on household appliances</li>
            <li data-id="element-564">Preventative maintenance services</li>
          </ul>
          <p className="text-slate-600 mb-6" data-id="element-565">
            All services are provided for domestic use only. We do not offer
            commercial or industrial repair services.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-566">
            2. Diagnostic Fees
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-567">
            The diagnostic fee is earned once our engineer has attended your
            property and completed the fault assessment. This fee covers the
            engineer's time, expertise, and travel costs, regardless of whether
            you proceed with the recommended repairs.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-568">
            3. Quotes and Approval
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-569">
            All quotes for parts and additional labour are provided after the
            diagnostic assessment. No repair work or parts will be ordered
            without your explicit approval. Quotes are valid for 30 days from
            the date of issue.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-570">
            4. Workmanship Assurance
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-571">
            We stand behind the quality of our repair work. If a fault recurs
            within 90 days due to our workmanship, we will return to assess and
            rectify the issue at no additional labour charge. This assurance
            does not cover new faults, customer misuse, or issues unrelated to
            our original repair work.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-572">
            5. Exclusions
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-573">We are not responsible for:</p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-574">
            <li data-id="element-575">Pre-existing faults not disclosed at booking</li>
            <li data-id="element-576">Damage caused by customer misuse or neglect</li>
            <li data-id="element-577">Faults arising from unauthorised repairs by third parties</li>
            <li data-id="element-578">Non-standard modifications to appliances</li>
            <li data-id="element-579">Normal wear and tear</li>
            <li data-id="element-580">Acts of nature or circumstances beyond our control</li>
          </ul>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-581">
            6. Liability Cap
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-582">
            Our total liability for any service provided is limited to the cost
            of that specific service. We maintain appropriate professional
            indemnity and public liability insurance for work carried out in
            your property.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-583">
            7. Payment Terms
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-584">
            Payment is due upon completion of the service. We accept secure
            payments through Stripe, including all major credit and debit cards.
            Diagnostic fees are payable at the time of the engineer's visit.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-585">
            8. Customer Responsibilities
          </h2>
          <p className="text-slate-600 mb-4" data-id="element-586">You agree to:</p>
          <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6" data-id="element-587">
            <li data-id="element-588">Provide accurate information about the appliance and fault</li>
            <li data-id="element-589">Ensure safe access to the appliance</li>
            <li data-id="element-590">
              Be present or arrange for an adult to be present during visits
            </li>
            <li data-id="element-591">Inform us of any hazards or access issues in advance</li>
            <li data-id="element-592">Disconnect and move appliances if requested</li>
          </ul>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-593">
            9. Force Majeure
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-594">
            We shall not be liable for any failure to perform our obligations
            due to circumstances beyond our reasonable control, including but
            not limited to severe weather, natural disasters, strikes, or
            government restrictions.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-595">
            10. Governing Law
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-596">
            These terms and conditions are governed by English law. Any disputes
            arising from our services will be subject to the exclusive
            jurisdiction of the courts of England and Wales.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-597">
            11. Amendments
          </h2>
          <p className="text-slate-600 mb-6" data-id="element-598">
            We reserve the right to update these terms and conditions. Any
            changes will be posted on this page with an updated revision date.
            Your continued use of our services after changes constitutes
            acceptance of the revised terms.
          </p>
          <h2 className="text-2xl font-semibold text-slate-800 mt-8 mb-4" data-id="element-599">
            Contact Information
          </h2>
          <p className="text-slate-600" data-id="element-600">
            Brighthands
            <br data-id="element-601" />
            5 London Rd, Portsmouth PO2 0BQ
            <br data-id="element-602" />
            Email: Sumittandon092@gmail.com
            <br data-id="element-603" />
            Phone: 0800 055 4969
          </p>
        </div>
      </div>
    </div>;
}